import { Asterisk } from "lucide-react";

const ITEMS = [
    "Price Comparison",
    "Coupons & Deals",
    "Quick Commerce",
    "Flights",
    "Hotels",
    "AI Search",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-xl sm:text-2xl font-medium uppercase tracking-[0.14em] text-india">
                    {item}
                </span>
                <Asterisk className="h-6 w-6 shrink-0 text-saffron" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="overflow-hidden border-y border-ink/10 bg-cream py-6"
        aria-hidden="true"
    >
        <div className="flex w-max animate-marquee">
            <Row />
            <Row />
            <Row />
            <Row />
        </div>
    </div>
);

export default Marquee;
